// extracted by mini-css-extract-plugin
module.exports = {"pdfmodal":"PdfPreview_pdfmodal__6-8ok","iframe":"PdfPreview_iframe__1r8bV"};